export const queryObjectProducts = (param, next = '') => {
  return {
    query: `
    {
      products(first: 100, where: {search: "${param}"}, after: "${next}") {
        edges {
          node {
            id
            link
            slug
            title
            uri
            product {
              code
              tradePrice
              brand {
                slug
                name
              }
              productGallery {
                image
              }
            }
            productCategories {
              edges {
                node {
                  name
                  slug
                  productCategoryExtras {
                    categoryIcon {
                      sourceUrl
                    }
                  }
                  parent {
                    node {
                      name
                      slug
                    }
                  }
                }
              }
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  `}
};

export const queryObjectCourses = (param = '', next = '') => {
  return {
    query: `
    {
      courses(first: 100, where: {search: "${param}"}, after: "${next}") {
        edges {
          node {
            id
            databaseId
            title
            uri
            courses {
              type
              length
              code
              provider {
                name
                slug
                courseProviderInfo {
                  logo {
                    sourceUrl(size: MEDIUM)
                  },
                }
              }
            }
            courseCategories {
              nodes {
                name
                slug
              }
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  `}
};

export const queryObjectCourseDates = (next = '') => {
return {
  query: `
  {
    courseDates(first: 100, after: "${next}") {
      edges {
        node {
          id
          courseData {
            course {
              ... on Course {
                id
                databaseId
                courses {
                  code
                }
              }
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`}
}; 